import type { CustomTooltipProps } from 'ag-grid-react'
import type { ReactElement } from 'react'
import type { IAuthorization } from '~/types/authorization'

const CustomTooltip = ({ data }: CustomTooltipProps<IAuthorization>): ReactElement | null => {
  if (!data) return null

  const { description, key } = data

  return (
    <div className="custom-tooltip" style={{ backgroundColor: '#fff', border: '0.1rem solid #eee', padding: '1rem' }}>
      <span>{key}</span>
      {description.length ? (
        <>
          <br />
          <span>{description}</span>
        </>
      ) : null}
    </div>
  )
}

export default CustomTooltip
